import {View} from 'MWC';
import tpl from '../templates/energy-credit.jsx';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView.js';

export default class extends BaseNewCardView {
    template = tpl;
}
